export const FlagIcon = ({
  countryCode,
  alt,
  ...props
}: {
  countryCode: string;
  alt?: string;
} & React.ImgHTMLAttributes<HTMLImageElement>) => {
  const code = countryCode.toUpperCase();
  const src = `https://media.bb-escort.de/public/flags/${code}.svg`;

  return <img src={src} alt={alt || code} loading='lazy' {...props} />;
};
